import React from 'react';
import { PageLoader } from './LoadingComponents';

class LazyLoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Lazy loading error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: '200px',
          flexDirection: 'column',
          padding: '2rem'
        }}>
          <h3 style={{ color: '#ef4444', marginBottom: '1rem' }}>
            Something went wrong
          </h3>
          <p style={{ color: '#6b7280', marginBottom: '1.5rem', textAlign: 'center' }}>
            Failed to load the component. Please try refreshing the page.
          </p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '0.75rem 1.5rem',
              border: 'none',
              borderRadius: '6px',
              background: '#6366f1',
              color: 'white',
              cursor: 'pointer'
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

// Wrapper component that combines Suspense and ErrorBoundary
const LazyWrapper = ({ children, fallback = <PageLoader text="Loading..." /> }) => {
  return (
    <LazyLoadErrorBoundary>
      <React.Suspense fallback={fallback}>
        {children}
      </React.Suspense>
    </LazyLoadErrorBoundary>
  );
};

export default LazyWrapper;
export { LazyLoadErrorBoundary };
